import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO component for page-level meta tags.
 * @param {string} title - Page title
 * @param {string} description - Meta description
 * @param {string} keywords - Meta keywords (comma-separated)
 * @param {string} canonical - Canonical URL (optional)
 */
export default function SEO({ title, description, keywords, canonical }) {
  return (
    <Helmet>
      <html lang="de" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
}
